import bem from 'utils/bem';

export const mobileAppPrompt = bem('mobile-app-prompt');
